import React from "react";
import styles from "./LPStickyForm.module.css";
import dynamic from "next/dynamic";

// Dynamically import RequestForm with no SSR
const RequestForm = dynamic(() => import("../RequestForm/RequestForm"), {
  ssr: false,
});

interface LPStickyFormProps {
  programName?: string;
  title?: string;
  programOfIntrestLP?: any;
  data?: any;
  isImageBanner?: any;
  programOfInterestMultipleOptionList?: any;
}

const LPStickyForm: React.FC<LPStickyFormProps> = ({
  programName,
  title,
  programOfIntrestLP,
  data,
  isImageBanner,
  programOfInterestMultipleOptionList,
}) => {
  const handleFormSubmit = () => {};

  return (
    <div
      className={styles.formContainer}
      style={isImageBanner ? { marginTop: "-532px" } : {}}
    >
      <div className={styles.phoneInputWrapper}>
        <RequestForm
          programName={programName}
          onFilledFieldsChange={() => {}}
          handleStep={() => {}}
          onFormSubmit={handleFormSubmit}
          isLpPage
          programOfIntrestLP={programOfIntrestLP}
          title={data?.title || title}
          btnText={data?.cta}
          programOfInterestMultipleOptionList={programOfInterestMultipleOptionList}
        />
      </div>
    </div>
  );
};

export default LPStickyForm;
